import { AgentCardDto, AgentCardId, EtxeApiSlugs, SearchAgentCardDataDto } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';

export class AgentCardConnector extends ApiConnector<AgentCardDto, AgentCardDto, AgentCardId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.AGENT_CARDS);
  }

  verify = (number: string) =>
    this.apiCaller.getRequest<SearchAgentCardDataDto>(this.apiPrefix, `${this.slug}/verification`, {
      params: { number },
    });

  verifyIdentity = (number: string) =>
    this.apiCaller.getRequest<{ match: boolean; card: AgentCardDto }>(
      this.apiPrefix,
      `${this.slug}/verify-identity`,
      {
        params: { number },
      },
    );
}
